var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.data),function(v){return _c('el-radio',{key:v,attrs:{"label":v},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }